import React, { useState } from "react";

function Topbar({ theme, setTheme, userEmail, onSignOut }) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showThemeMenu, setShowThemeMenu] = useState(false);

  return (
    <div className="topbar">
      <div className="topbar-brand">
        Household<span className="topbar-brand-accent">Expenses</span>
      </div>
      <div className="topbar-right">
        <div className="topbar-icon-wrap">
          <button
            className="topbar-icon-btn"
            onClick={() => {
              setShowThemeMenu(!showThemeMenu);
              setShowUserMenu(false);
            }}
          >
            ⚙️
          </button>
          {showThemeMenu && (
            <div className="topbar-dropdown">
              <button
                className="topbar-dropdown-item"
                onClick={() => {
                  setTheme("light");
                  setShowThemeMenu(false);
                }}
              >
                ☀️ Light theme
              </button>
              <button
                className="topbar-dropdown-item"
                onClick={() => {
                  setTheme("dark");
                  setShowThemeMenu(false);
                }}
              >
                🌙 Dark theme
              </button>
            </div>
          )}
        </div>

        <div className="topbar-icon-wrap">
          <button
            className="topbar-user-chip"
            onClick={() => {
              setShowUserMenu(!showUserMenu);
              setShowThemeMenu(false);
            }}
          >
            <span className="topbar-avatar">{userEmail?.[0]?.toUpperCase()}</span>
            <span className="topbar-user-name">{userEmail?.split("@")[0]}</span>
            <span className="topbar-caret">▾</span>
          </button>
          {showUserMenu && (
            <div className="topbar-dropdown">
              <div className="topbar-dropdown-email">{userEmail}</div>
              <button className="topbar-dropdown-item" onClick={onSignOut}>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Topbar;